/*
 * The dashed divider.
 *
 * One scrubbed timeline: the line draws itself left to right, and the icon pops
 * in at the halfway mark — so it reads as something the line arrives at rather
 * than an ornament sitting there waiting.
 */
import { defineScene, reducedMotion } from '@theme/about-story';

defineScene('about-divider', (root, gsap) => {
	const mask = root.querySelector('[data-about-divider-mask]');
	const svg = root.querySelector('[data-about-divider-svg]');
	const icon = root.querySelector('[data-about-divider-icon]');

	if (reducedMotion()) {
		if (mask) gsap.set(mask, { drawSVG: '100%' });
		return;
	}

	const timeline = gsap.timeline({
		scrollTrigger: { trigger: svg || root, start: 'top 85%', end: 'bottom 55%', scrub: 1 },
	});

	if (mask) {
		timeline.fromTo(mask, { drawSVG: '0%' }, { drawSVG: '100%', ease: 'none', duration: 1 }, 0);
	}

	if (icon) {
		timeline.fromTo(
			icon,
			{ autoAlpha: 0, scale: 0.4 },
			{ autoAlpha: 1, scale: 1, ease: 'back.out(2)', duration: 0.3 },
			0.5
		);
	}
});
